import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 px-4 md:py-24 bg-white" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-126">
            El momento donde todo se rompe
          </h2>

          <div className="prose prose-lg max-w-none text-gray-700" data-id="element-127">
            <p className="text-xl font-medium text-gray-800 mb-6" data-id="element-128">
              Voy a decirte algo que casi nadie te dice de frente:
              <br data-id="element-129" />
              <span className="text-[#C05621] font-bold" data-id="element-130">
                Tú no necesitas más información.
              </span>
            </p>

            <p className="mb-6" data-id="element-131">
              Necesitas un sistema que funcione cuando estás cansado, con
              hambre, con prisa… y con antojo.
            </p>

            <p className="mb-8" data-id="element-132">
              Porque si tienes prediabetes o diabetes tipo 2, no te falla la
              inteligencia. Te falla el "qué hago exactamente en este momento".
            </p>

            <div className="bg-red-50 rounded-xl p-8 border border-red-100 mb-10" data-id="element-133">
              <div className="flex items-start mb-4" data-id="element-134">
                <AlertTriangle className="w-6 h-6 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-135" />
                <h3 className="text-xl font-bold text-gray-900 m-0" data-id="element-136">
                  No se rompe cuando estás motivado. Se rompe cuando:
                </h3>
              </div>

              <ul className="space-y-3 pl-2" data-id="element-137">
                {['llegas tarde y lo único que hay es un plato servido', "estás en la taquería y 'nomás uno más'", 'hay pan dulce en la oficina', "te invitan a una fiesta y no quieres ser 'el especial'", 'traes estrés y tu cuerpo pide azúcar'].map((item, i) => <li key={i} className="flex items-start text-gray-800" data-id="element-138">
                    <XCircle className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-139" />
                    <span data-id="element-140">{item}</span>
                  </li>)}
              </ul>
            </div>

            <p className="text-xl text-center font-medium text-gray-800" data-id="element-141">
              En esos momentos, una dieta rígida no te ayuda. Te deja con dos
              opciones: sufrir, o rendirte.
              <br data-id="element-142" />
              <span className="block mt-2 font-bold text-2xl text-gray-900" data-id="element-143">
                Y ahí nace el ciclo: todo o nada.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}